import { render, staticRenderFns } from "./auto-scroll.vue?vue&type=template&id=7e9d87bc&scoped=true"
import script from "./auto-scroll.vue?vue&type=script&lang=js"
export * from "./auto-scroll.vue?vue&type=script&lang=js"
import style0 from "./auto-scroll.vue?vue&type=style&index=0&id=7e9d87bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9d87bc",
  null
  
)

export default component.exports